import { CommonModule } from '@angular/common'
import { ChangeDetectorRef, Compiler, Component, ComponentRef, EventEmitter, Injector, Input, NgModule, NgModuleRef, Output, ViewChild, ViewContainerRef } from '@angular/core'
import { FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms'
import { MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule, MatMenuModule, MatRadioModule, MatSelectModule, MatTableModule } from '@angular/material'
import { RouterModule } from '@angular/router'
import { FormAtylBase } from '../../../../../motor-form-atyl/form-atyl-base'
import { FormAtylInputModule } from '../../../../../motor-form-atyl/form-atyl-components/form-atyl-input/form-atyl-input.module'
import { FormDialogErrorsComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-errors/form-dialog-errors.component'
import { TableAtylDisplayModule } from '../../../../../motor-form-atyl/form-atyl-components/form-table-atyl-display/table-atyl-display.module'
import { FormAtylControlService } from '../../../../../motor-form-atyl/form-atyl-control.service'
import { FormAtylService } from '../../../../../motor-form-atyl/form-atyl.service'
import { DialogService } from '../../../../../services'

@Component({
	selector: 'atyl-nomade-form',
	templateUrl: './nomade-form.component.html',
	styleUrls: ['./nomade-form.component.scss']
})
export class NomadeFormComponent {

	@Input() components: string = ''
	@Input() template: string = ''
	@Input() nextButton: boolean
	@Input() prevButton: boolean
	@Output() submit: EventEmitter<any> = new EventEmitter()
	form: any
	inputsControls: any[] = []
	error: string = ''
	cmpRef: ComponentRef<any>
	formHeight: string = '75vh'
	@ViewChild('atylMoteur', { read: ViewContainerRef, static: false }) atylMoteur: ViewContainerRef

	navigation: any

	constructor(
		private formAtylService: FormAtylService,
		private acs: FormAtylControlService,
		private compiler: Compiler,
		private injector: Injector,
		private moduleRef: NgModuleRef<any>,
		private dialogService: DialogService,
		private changeDetectorRef: ChangeDetectorRef
	) { }
	ngOnInit() {
		this.inputsControls = this.formAtylService.getAtylInputs(this.components)
		this.form = this.acs.toFormGroup(this.inputsControls)

		this.__createComponent__orShow__error()
	}
	ngAfterViewInit() {
		const dialogContainer = document.querySelector('.cdk-overlay-pane')
		if (dialogContainer) {
			this.formHeight = (dialogContainer.clientHeight - 115) + 'px'
			dialogContainer.addEventListener('resize', (e) => {
				this.formHeight = (dialogContainer.clientHeight - 115) + 'px'
			})
		}
		this.changeDetectorRef.detectChanges()
	}
	private __createComponent__orShow__error() {
		if (this.template && this.inputsControls) {
			this.createComponentFromRaw(this.template, this.inputsControls, this.form)
		}
		else if (!this.template && !this.inputsControls) {
			this.error = `Aucun champs ni template ont été trouvé, veuillez générer le formulaire par l'interface d'admin.`
		} else if (!this.template) {
			this.error = `Aucun template de formulaire n'a été trouvé, veuillez en générer un.`
		}
		else if (!this.inputsControls) {
			this.error = `Aucun champs de formulaire n'a été trouvé, veuillez en créer les champs correspondant au template.`
		}
	}
	private createComponentFromRaw(template: string, atylInputsToPass: FormAtylBase<any>[], formToPass: FormGroup) {
		// Let's say your template looks like `<h2><some-component [data]='data'></some-component>`
		// As you see, it has an (existing) angular component `some-component` and it injects it [data]

		// Now we create a new component. It has that template, and we can even give it data.

		const tmpCmp = this.__create__tmp__component__(template, atylInputsToPass, formToPass)

		// Now, also create a dynamic module.
		const tmpModule = this.__create__tmp__module__(tmpCmp)

		// Now compile this module and component, and inject it into that #atylMoteur in your current component template.
		this.__compile__module__(tmpModule)
	}
	private __create__tmp__component__(template: string, atylInputsToPass: FormAtylBase<any>[], formToPass: FormGroup) {
		return Component({ template })(class {
			// the class is anonymous. But it's a quite regular angular class. You could add @Inputs,
			// @Outputs, inject stuff etc. // <== no this is a lie.
			atylInputsControls: FormAtylBase<any>[]
			form: FormGroup
			component: any
			constructor() {
				this.atylInputsControls = atylInputsToPass
				this.form = formToPass
			}
			filterListComponent(listComponents: FormAtylBase<any>[], value: string): any {
				listComponents.forEach((component, index) => {
					if (component && component.ID === value)
						this.component = component
				})
				return this.component
			}
		})
	}
	private __create__tmp__module__(tmpCmp: any) {
		return NgModule({
			imports: [
				CommonModule,
				RouterModule,
				ReactiveFormsModule,
				FormsModule,
				MatCardModule,
				MatGridListModule,
				MatFormFieldModule,
				MatInputModule,
				MatCheckboxModule,
				MatDatepickerModule,
				MatRadioModule,
				MatSelectModule,
				MatTableModule,
				MatAutocompleteModule,
				MatIconModule,
				MatButtonModule,
				MatDialogModule,
				MatExpansionModule,
				MatMenuModule,
				TableAtylDisplayModule,
				FormAtylInputModule
			],
			declarations: [
				tmpCmp
			],
			entryComponents: [],
			providers: [
				{ provide: FormAtylService, useValue: this.formAtylService }
			]
		})(class { })
	}

	private __compile__module__(tmpModule: any) {
		this.compiler.compileModuleAndAllComponentsAsync(tmpModule)
			.then((factories) => {
				const f = factories.componentFactories[factories.componentFactories.length - 1]
				this.cmpRef = f.create(this.injector, [], null, this.moduleRef)
				this.cmpRef.instance.name = 'dynamic-form-atyl'
				this.atylMoteur.insert(this.cmpRef.hostView)
				const cards = Array.from(document.getElementsByTagName('app-form-atyl')[0].getElementsByTagName('mat-card'))
				cards.forEach((element, index) => {
					this.navigation.push({
						id: element.id,
						label: element.getElementsByTagName('mat-card-title')[0].innerHTML
					})
				})

			})
	}
	onValidate(btn: any, action?: any) {
		btn.disable = true
		let formformated = this.form.getRawValue()
		if (this.form.invalid) {
			this.__show__error__dialog__()
		}
		else {
			formformated['NOWORKFLOW'] = false
			this.__handel__form__navigation__(formformated, action)
			this.__do__submit__data(formformated, btn)
		}
	}
	private __do__submit__data(formformated: any, btn: any) {
		this.submit.emit(formformated)
	}

	private __show__error__dialog__() {
		this.dialogService.open(FormDialogErrorsComponent, {
			data: this.getFormValidationErrors(this.form.controls)
		})
	}

	getFormValidationErrors(controls: any, container?: any): any[] {
		let errors: any[] = []
		Object.keys(controls).forEach(key => {
			const control = controls[key] as FormGroup
			controls[key].markAsTouched()
			if (control instanceof FormGroup) {
				errors = errors.concat(this.getFormValidationErrors(control.controls, key))
			}
			const controlErrors: ValidationErrors = controls[key].errors
			if (controlErrors !== null) {
				this.__handel__errors__(key, container, controlErrors, errors)
			}
		})
		return errors
	}

	private __handel__errors__(key: string, container: any, controlErrors: ValidationErrors, errors: any[]) {
		let label = ''
		this.inputsControls.forEach((comp, index) => {
			if (comp.ID == key)
				label = comp.placeholder ? comp.placeholder : comp.label
			if (container) {
				if (container == comp.ID && comp.options.hasOwnProperty(key))
					label = comp.placeholder ? comp.placeholder : comp.label
				if (container == comp.ID && comp.type == key)
					label = comp.placeholder ? comp.placeholder : comp.label
			}
		})
		Object.keys(controlErrors).forEach(keyError => {
			errors.push({
				control_name: label,
				error_name: this.errorInputHandler(keyError),
				error_value: controlErrors[keyError]
			})
		})
	}
	errorInputHandler(errorname: string) {
		return errorname === 'required' ? 'Ce champ est obligatoire' : ''
	}
	private __handel__form__navigation__(formformated: any, action: any) {
		formformated['close'] = false
		if (action === 'prev') {
			formformated['prev'] = true
		}
		if (action === 'next') {
			formformated['next'] = true
		}
		if (action === 'close') {
			formformated['close'] = true
		}
	}
}
